var ChildContextMenuView = require('childcontextmenuview');


var ChannelContextMenuView = ChildContextMenuView.extend({
    el: '#channelContextMenu',
    initialize: function (options) {
        this.mode = this.$('.modeLine');
        this.modeList = this.$('.modeList');
        this.modActions = this.$('.modAction');
        
        ChildContextMenuView.prototype.initialize.call(this, options);
    },
    events: $.extend({}, ChildContextMenuView.prototype.events, {
        'buttonClick button.topic': 'clickTopic',
        'buttonClick button.invite': 'clickInvite',
        'buttonClick button.leave': 'clickLeave',
        'buttonClick button.rejoin': 'clickRejoin',
        'buttonClick button.bans': 'clickBans',
        'buttonClick button.members': 'clickMembers',
        'buttonClick button.notifyAll': 'clickNotifyAll',
        'buttonClick button.rename': 'clickRename',
        'buttonClick button.delete': 'clickDelete'
    }),
    clickTopic: function (e) {
        e.preventDefault();
        if (this.buffer.canSetTopic()) {
            this.hide();
            this.buffer.trigger('topicPrompt');
            this.clearContext();
        }
    },
    clickInvite: function (e) {
        e.preventDefault();
        var org = this.buffer.connection.getOrg();
        if (org) {
            if (org.isAdmin()) {
                this.hide();
                this.buffer.session.trigger('navigate', '?/team=' + org.id, {trigger: true});
                this.clearContext();
            }
        } else if (this.buffer.isActive()) {
            this.hide();
            this.buffer.trigger('invitePrompt');
            this.clearContext();
        }
    },
    clickLeave: function (e) {
        e.preventDefault();
        if (this.buffer.isActive()) {
            this.hide();
            this.buffer.part();
            this.clearContext();
        }
    },
    clickRejoin: function (e) {
        e.preventDefault();
        if (!this.buffer.isActive()) {
            this.hide();
            this.buffer.join();
            this.clearContext();
        }
    },
    clickBans: function (e) {
        e.preventDefault();
        if (this.buffer.isActive()) {
            this.hide();
            this.buffer.banList();
            this.clearContext();
        }
    },
    clickMembers: function (e) {        
        e.preventDefault();        
        if (this.buffer.isActive()) {      
            this.hide();
            this.buffer.setShowMembersPref(!this.buffer.shouldShowMemberList());
            this.clearContext();
        }
    },
    clickNotifyAll: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setNotifyAllPref(!this.buffer.shouldNotifyAll());
        this.clearContext();
    },
    clickRename: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.trigger('renamePrompt', this.buffer.getName());
        this.clearContext();
    },
    clickDelete: function (e) {
        this.hide();
        this.buffer.trigger('deleteConfirm');
        this.clearContext();
        return false;
    },
    setModeInfo: function () {
        this.mode.empty();
        this.modeList.empty();
        if (this.buffer.modeString) {
            this.mode.html("Mode: +" + this.formatter.render(this.buffer.modeString)).show();
            if (this.buffer.hasMode('i')) {
                this.modeList.append($('<li class="inviteOnly">').text('Invite-only (i)'));
            }
            if (this.buffer.isPassworded()) {
                this.modeList.append($('<li class="password">').html('Password: ' + this.formatter.render(this.buffer.getKey()) + ' (k)'));
            }
            if (this.buffer.hasMode('l')) {
                this.modeList.append($('<li class="limited">').text('Limited to ' + this.buffer.getMode('l') + ' members (l)'));
            }
            if (this.buffer.hasMode('m')) {
                this.modeList.append($('<li class="moderated">').text('Moderated: Only ops and voiced members may talk (m)'));
            }
            if (this.buffer.hasMode('n')) {
                this.modeList.append($('<li class="noExternal">').text('No messages allowed from outside the channel (n)'));
            }
            if (this.buffer.hasMode('p')) {
                this.modeList.append($('<li class="private">').text('Private: Membership is only visible to other members (p)'));
            }
            if (this.buffer.hasMode('s')) {
                this.modeList.append($('<li class="secret">').text('Secret: This channel is unlisted and membership is only visible to other members (s)'));
            }
            if (this.buffer.hasMode('t')) {
                this.modeList.append($('<li class="topicControl">').text('Only ops can set the topic (t)'));
            }
            
            this.mode.show();
            this.modeList.show();
        } else {
            this.mode.hide();
            this.modeList.hide();
        }
    },
    onShow: function () {
        // Mode
        this.setModeInfo();
        
        // Leave/rejoin
        this.deactivateItem(this.$('li.leave'), !this.buffer.isActive(), true);
        this.deactivateItem(this.$('li.rejoin'), this.buffer.isActive(), true);
        this.deactivateItem(this.$('li.rename'), this.buffer.isActive(), true);
        
        // Invite
        var org = this.buffer.connection.getOrg();
        var canInvite = org ? org.isAdmin() : true;
        this.deactivateItem(this.$('li.invite'), !canInvite, true);
        
        // Topic control
        this.deactivateItem(this.$('li.topic'), !this.buffer.canSetTopic());
        
        // Members list
        this.enableItem(this.$('li.showMembers'), this.buffer.shouldShowMemberList());
        
        // Notify on all messages
        this.enableItem(this.$('li.notifyAll'), this.buffer.shouldNotifyAll());
        this.deactivateItem(this.$('li.notifyAll'), this.buffer.isSlackMultiPersonDm(), true);

        
        // Mod actions
        var isMod = this.buffer.isMod();
        this.deactivateItem(this.modActions, !isMod, true);
        
        ChildContextMenuView.prototype.onShow.call(this);
    }
});


module.exports = ChannelContextMenuView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/channelcontextmenuview.js
// module id = EAmV
// module chunks = 1